import { useQuery as useRelatedSearchesQuery } from "@faire/web-api/api/seo/brand-explore-terms/brandToken/get-hooks";
import { trackSeoRelatedSearchesExploreLinkingRenovationClick } from "@faire/web-api/events/seo/click/relatedSearchesExploreLinkingRenovation";
import { trackSeoRelatedSearchesExploreLinkingRenovationView } from "@faire/web-api/events/seo/view/relatedSearchesExploreLinkingRenovation";
import { getSpacing } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import React, { Suspense } from "react";
import styled from "styled-components";

import { LazySearchProductsRelatedSearchSection } from "@faire/retailer/components/SearchProducts/SearchProductsRelatedSearchSection";
import { exploreSearch } from "@faire/retailer/lib/seoPaths";

import { Wrapper } from "../components/common";

interface IProps {
  brandToken: string;
}

export const RelatedSearches: React.FC<IProps> = ({ brandToken }) => {
  const {
    data,
    isPending: isLoading,
    isError,
  } = useRelatedSearchesQuery(brandToken);

  const relatedSearches = data?.explore_terms;

  if (!relatedSearches?.length || isLoading || isError) {
    return null;
  }

  return (
    <Wrapper>
      <Suspense fallback={null}>
        <StyledLazySearchProductsRelatedSearchSection
          relatedSearchTerms={relatedSearches}
          generateSearchTermUrl={exploreSearch}
          onSearchTermClick={(searchTerm) =>
            trackSeoRelatedSearchesExploreLinkingRenovationClick(searchTerm)
          }
          onRelatedSearchListView={
            trackSeoRelatedSearchesExploreLinkingRenovationView
          }
        />
      </Suspense>
    </Wrapper>
  );
};

const StyledLazySearchProductsRelatedSearchSection = styled(
  LazySearchProductsRelatedSearchSection
)`
  padding: ${getSpacing(0, "2x", "6x", "2x")};

  ${responsiveMediaQueries.tabletAndAbove} {
    padding-bottom: ${getSpacing("10x")};
  }
`;
